import { Component, OnInit, Inject, ViewChild, Optional, OnDestroy, HostListener, ViewEncapsulation } from '@angular/core';
import { UntypedFormControl, Validators, UntypedFormGroup, UntypedFormBuilder, UntypedFormArray, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatRadioButton } from '@angular/material/radio';
import { MatCheckbox } from '@angular/material/checkbox';

import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

import { CookieService } from 'ngx-cookie-service';
import { LoggingService } from '@EfsServices/logging.service';
import { DataSharingService } from '../shared/services/data-sharing.service';
import { EfsApiService } from '@EfsServices/efs-api.service';
import { environment } from '@efsEnvironments/environment';
import { GenericPopupComponent } from '@EfsReusable/generic-popup/generic-popup.component';
import { ApiErrorHandlingService } from '@EfsServices/api-error-handling.service';
import { SessionTimerService } from '@EfsServices/session-timer.service';
import { PermissionHandlingService } from '@efsShared/services/permission-handling.service';

@Component({
    selector: 'app-mailer-id-setup',
    templateUrl: './mailer-id-setup.component.html',
    styleUrls: ['../../assets/styles/styles.scss'],
    standalone: false
})
export class MailerIdSetupComponent {
  moduleInfo = {
    moduleName: 'moduleMailerIdSetup',
    moduleVersion: '0.2.0',
  };

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  dataSource = new MatTableDataSource<any>();
  displayedColumns: string[] = [
    'imbMailerId',
    'imbMailerSequence',
    'acsMethodCode',
    'facilityCd'
  ]
  showTable = false;
  tableData = [];

  showAddNewIMBForm = false;

  inactivateDisable = true;
  submitDisable = true;
  searchDisable = true;

  popupDialogRef;

  imbMailerIdControl = new UntypedFormControl({ value: '', disabled: false }, [
    Validators.pattern('^[0-9]*$'),
    // Validators.required,
  ]);

  addImbMailerIdControl = new UntypedFormControl({ value: '', disabled: false }, [
    Validators.pattern('^[0-9]*$'),
    Validators.required,
  ]);

  imbMailerSequenceControl = new UntypedFormControl({ value: '', disabled: false }, [
    Validators.pattern('^[1-9][0-9]*$'),
    Validators.required,
  ]);

  acsMethodControl = new UntypedFormControl({ value: '', disabled: false }, [
    // Validators.pattern('^[a-zA-Z0-9_-]*$'),
    Validators.required,
  ]);

  facilityControl = new UntypedFormControl({ value: '', disabled: false }, [
    // Validators.pattern('^[a-zA-Z0-9_]*$'),
    Validators.required,
  ]);

  multiselect = new FormControl([], [
    Validators.required
  ]);

  acsMethods: any[] = ['null'];

  selectOptionList: any[] = ['EDH', 'HAR', 'KCW', 'CPL', 'EDG', 'NTLEDH', 'NTLCLF'];
  selectOptionListUAT: string[] = ['HAR'];
  selectOptions: SelectOption[] = [
    { value: 'steak-0', viewValue: 'Client Services' },
  ];

  constructor(
    private dataSharingService: DataSharingService,
    private cookieService: CookieService,
    private router: Router,
    @Optional() @Inject(MAT_DIALOG_DATA) public data,
    private efsApiService: EfsApiService,
    public dialog: MatDialog,
    public loggingService: LoggingService,
    private apiErrorHandlingService: ApiErrorHandlingService,
    private sessionTimerService: SessionTimerService,
    private formBuilder: UntypedFormBuilder,
    public permissionHandlingService: PermissionHandlingService,
  ) {
    // this.form = this.formBuilder.group({
    //   checkBoxes: new UntypedFormArray([], [
    //     // Validators.required
    //   ])
    // });
  }

  ngOnInit(): void {
    // disable acs method control
    this.acsMethodControl.disable();

    this.dataSharingService.shareData(this.moduleInfo); // share name and version of module; update here
    this.loggingService.logInfo('In mailer ID Setup page');
    this.dataSharingService.shareData(this.moduleInfo); // share name and version of module; update here

    // if a table has embedded json, it must be added to sorting data accessor in order to sort by it
    this.dataSource.sortingDataAccessor = (item, property) => {
      // console.log(JSON.stringify(item));
      switch (property) {
        case 'clientMasterNm': return item.clientMasterNm;
        case 'parentClientId': return item.parentClientId;
        case 'blnktSlsOrderCd': return item.blnktSlsOrderCd;
        case 'blnktSlsOrderDesc': return item.blnktSlsOrderDesc;
        case 'productionLine': return item.productionLine;
        case 'sla': return item.sla;
        case 'clientId': return item.clientId;
        case 'clientNm': return item.clientNm;
        case 'facilityCd': return item.facilityCd;
        default: return item[property];
      }
    };

    this.checkImbMailerIdInput();
    this.checkSubmitFieldInput();
    // get the acs method types
    this.serviceGetReferenceType();
    // get all facilities
    this.serviceGetAllFacilities();




    // session timer startup for detecting session
    this.sessionTimer();
  }

  // session timer method for tracking session using mouse movement
  @HostListener('mousemove')
  sessionTimer() {
    this.sessionTimerService.checkSessionStatus();
  }
  // stop session timers once the modal is removed
  ngOnDestroy(): void {
    this.sessionTimerService.stopTimers();
  }

  // services

  serviceGetReferenceType() {
    this.efsApiService.getReferenceValuesByTypeCS('ACS_METHOD').subscribe((data: any) => {
      console.log(JSON.stringify(data));

      this.acsMethods = data;

    }, error => {
      this.apiErrorHandlingService.errorStatusHandler(error);
    });
  }

  serviceGetAllFacilities() {
    this.efsApiService.getFacilitiesCS().subscribe((data: any) => {
      console.log(JSON.stringify(data));

      this.selectOptionList = data;

    }, error => {
      this.apiErrorHandlingService.errorStatusHandler(error);
    });
  }

  serviceInsertImbMailerId(mailerIdBody) {
    this.efsApiService.insertImbMailerId(mailerIdBody).subscribe((data: any) => {
      console.log(JSON.stringify(data));
      this.submitDisable = false;
      this.cancelFormButton();

      this.popupWarning(false, 'IMB Mailer ID ' + mailerIdBody.imbMailerId + ' successfully added');

    }, error => {
      this.submitDisable = false;
      this.apiErrorHandlingService.errorStatusHandler(error);
    });
  }

  serviceInactivateImbMailerId(imbMailerId) {
    this.efsApiService.inactivateImbMailerId(imbMailerId).subscribe((data: any) => {
      console.log(JSON.stringify(data));
      this.inactivateDisable = false;

      this.popupWarning(false, 'IMB Mailer ID ' + imbMailerId + ' has been successfully inactivated');

    }, error => {
      this.inactivateDisable = false;
      this.apiErrorHandlingService.errorStatusHandler(error);
    });
  }

  // end of services

  // for checking if there is any input in the search/inactivate box
  checkImbMailerIdInput() {
    this.imbMailerIdControl.valueChanges.subscribe(input => {
      if (input.length > 0) {
        // check if input is valid
        if (this.imbMailerIdControl.status === 'VALID') {
          this.searchDisable = false;
          this.inactivateDisable = false;
        } else {
          this.searchDisable = true;
          this.inactivateDisable = true;
        }
      } else {
        this.searchDisable = true;
        this.inactivateDisable = true;
      }

    });
  }
  // check for input in all submit fields
  checkSubmitFieldInput() {

    this.addImbMailerIdControl.valueChanges.subscribe(input => {
      if (this.addImbMailerIdControl.status === 'VALID' &&
        this.imbMailerSequenceControl.status === 'VALID' &&
        // this.acsMethodControl.status === 'VALID' &&
        this.facilityControl.status === 'VALID'
      ) {
        this.submitDisable = false;
      } else {
        this.submitDisable = true;
      }
    });
    this.imbMailerSequenceControl.valueChanges.subscribe(input => {
      if (this.addImbMailerIdControl.status === 'VALID' &&
        this.imbMailerSequenceControl.status === 'VALID' &&
        // this.acsMethodControl.status === 'VALID' &&
        this.facilityControl.status === 'VALID'
      ) {
        this.submitDisable = false;
      } else {
        this.submitDisable = true;
      }
    });
    this.acsMethodControl.valueChanges.subscribe(input => {
      if (this.addImbMailerIdControl.status === 'VALID' &&
        this.imbMailerSequenceControl.status === 'VALID' &&
        // this.acsMethodControl.status === 'VALID' &&
        this.facilityControl.status === 'VALID'
      ) {
        this.submitDisable = false;
      } else {
        this.submitDisable = true;
      }
    });
    this.facilityControl.valueChanges.subscribe(input => {
      if (this.addImbMailerIdControl.status === 'VALID' &&
        this.imbMailerSequenceControl.status === 'VALID' &&
        // this.acsMethodControl.status === 'VALID' &&
        this.facilityControl.status === 'VALID'
      ) {
        this.submitDisable = false;
      } else {
        this.submitDisable = true;
      }
    });
  }

  searchButton() {
    if (this.imbMailerIdControl.status === 'VALID') {
      this.showTable = true;

      const imbMailerId = this.imbMailerIdControl.value;
      this.efsApiService.getImbMailerId(imbMailerId).subscribe((data: any) => {
        console.log(JSON.stringify(data));

        if (Object.keys(data).length === 0) {
          // popup message if no data found.
          this.popupWarning(false, 'nothing found for IMB Mailer ID ' + imbMailerId + '.');
          this.showTable = false;
        } else {
          // fill out the table here
          const dataList = [data];
          this.dataSource.data = dataList;
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          this.tableData = data;

        }

      }, error => {
        this.showTable = false;
        this.apiErrorHandlingService.errorStatusHandler(error);
      });
    } else {
      this.popupWarning(false, 'Please Enter a valid IMB Mailer ID');
    }
  }

  addNewButton() {
    // clear the data from the form
    this.addImbMailerIdControl.reset();
    this.imbMailerSequenceControl.reset();
    this.acsMethodControl.reset();
    this.facilityControl.reset();

    // set default to hyphen
    for (const item of this.acsMethods) {
      if (item.referenceDesc === '-') {
        this.acsMethodControl.setValue(item);
      }
    }
    this.showAddNewIMBForm = true;
  }

  inactivateButton() {
    if (this.imbMailerIdControl.status === 'VALID') {
      this.inactivateDisable = true;
      this.popupWarning(true, 'Are you sure you want to inactivate mailer ID ' + this.imbMailerIdControl.value + '?');
      this.popupDialogRef.afterClosed().subscribe(result => {
        if (result) {
          console.log('user clicked yes');
          // inactivate user api call
          const imbMailerId = this.imbMailerIdControl.value;
          this.serviceInactivateImbMailerId(imbMailerId);
        } else {
          this.inactivateDisable = false;
        }
      })
    } else {
      this.popupWarning(false, 'Please Enter a valid IMB Mailer ID');
    }
  }

  submitFormButton() {
    if (this.addImbMailerIdControl.status === 'VALID' &&
      this.imbMailerSequenceControl.status === 'VALID' &&
      // this.acsMethodControl.status === 'VALID' &&
      this.facilityControl.status === 'VALID'
    ) {
      this.submitDisable = true;

      // create a body to submit 
      const newMailerId = {
        imbMailerId: this.addImbMailerIdControl.value,
        acsMethodCd: this.acsMethodControl.value.referenceCd,
        imbSequence: this.imbMailerSequenceControl.value,
        facilityCd: this.facilityControl.value.facilityCd,

      }

      console.log(JSON.stringify(newMailerId));
      this.serviceInsertImbMailerId(newMailerId);

    }

  }

  cancelFormButton() {
    // clear the data from the form
    this.addImbMailerIdControl.reset();
    this.imbMailerSequenceControl.reset();
    this.acsMethodControl.reset();
    this.facilityControl.reset();

    this.showAddNewIMBForm = false;


  }

  setFacilityDropdown() {


  }

  setACSMethod() {
    console.log(this.acsMethodControl.value);
  }

  popupWarning(questionType, message) {
    this.popupDialogRef = this.dialog.open(GenericPopupComponent, {
      width: '450px',
      height: '250px',
      panelClass: 'popup-borders',
      data: {
        questionType,
        title: 'Alert',
        message
      }
    });
    return true;
  }



}

export interface SelectOption {
  value: string;
  viewValue: string;
}